'use client';

import './globals.css';
import * as Sentry from '@sentry/nextjs';
import { Button } from '@/components/ui/button/button';
import { Label } from '@/components/ui/label/label';
import UnknownError from '@/icons/iconsComponent/UnknownError';
import { useEffect } from 'react';
import localFont from 'next/font/local';

const iranSans = localFont({
  src: [
    {
      path: '../public/IRANSansXV.woff2',
      weight: '100 900',
      style: 'normal',
    },
  ],
  variable: '--font-iranSans',
});

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  useEffect(() => {
    const goftino = (window as any).Goftino;
    if (goftino?.setWidget) {
      goftino.setWidget({ hasIcon: false });
    }
  }, []);

  return (
    <html lang='fa' translate='no' className={`${iranSans.variable}`}>
      <body>
        <div className='flex w-full flex-col items-center justify-center h-[95vh] gap-y-2'>
          <UnknownError className='text-pics' />
          <Label className='body-14-bold'>خطای ناشناخته</Label>
          <div className='body-12-regular mb-1'>
            ضمن عرض پوزش بابت خطای پیش آمده، لطفا مجددا صفحه را بارگذاری کنید.
          </div>
          <Button
            className='flex flex-row gap-x-2 items-center'
            onClick={() => window.location.reload()}
          >
            بارگذاری مجدد
          </Button>
        </div>
      </body>
    </html>
  );
}
